// This acts as a store away from Redux's own state tree.
// It can be used to store things that cannot be stored
// in Redux's state, such as functions, classes, and
// anything else that's not easily serializable to JSON.
const appConfig = {};
export default appConfig;
